import React from 'react';
import { ReactComponent as MicrowaveIcon } from '../../../assets/images/microwave.svg';
import { ReactComponent as DishwasherIcon } from '../../../assets/images/dishwasher.svg';
import { ReactComponent as FreezerIcon } from '../../../assets/images/freezer.svg';
import { ReactComponent as DisposalIcon } from '../../../assets/images/garbage-disposal.svg';
import { ReactComponent as ExhaustIcon } from '../../../assets/images/exhaust-fan.svg';
import { ReactComponent as RefrigeratorIcon } from '../../../assets/images/refrigerator.svg';
import { ReactComponent as ExternalWaterLine } from '../../../assets/images/external-water.svg';
import { ReactComponent as GarageOpener } from '../../../assets/images/garage-opener.svg';
import { ReactComponent as CeilingFan } from '../../../assets/images/ceiling-fan.svg';
import { ReactComponent as Humidifier } from '../../../assets/images/humidifier.svg';
import { ReactComponent as WaterHeater } from '../../../assets/images/water-heater.svg';
import { ReactComponent as HeatingSystem } from '../../../assets/images/heating-system.svg';
import { ReactComponent as DuctWorkIcon } from '../../../assets/images/ductwork.svg';
import { ReactComponent as PlumbingStoppage } from '../../../assets/images/plumbing-stoppage.svg';
import { ReactComponent as PlumbingSystem } from '../../../assets/images/plumbing-system.svg';
import { ReactComponent as RangeIcon } from '../../../assets/images/range.svg';
import { ReactComponent as ElectricalSystem } from '../../../assets/images/electrical-system.svg';
import { ReactComponent as SpaIcon } from '../../../assets/images/hot-tub.svg';
import { ReactComponent as SwimIcon } from '../../../assets/images/swim.svg';
import { ReactComponent as TermiteTreatment } from '../../../assets/images/termite.svg';
import { ReactComponent as PlumbingIcon } from '../../../assets/images/plumbing.svg';
import { ReactComponent as WellPump } from '../../../assets/images/well-pump.svg';
import { ReactComponent as DryerIcon } from '../../../assets/images/dryer.svg';
import { ReactComponent as WasherIcon } from '../../../assets/images/washer.svg';
import { ReactComponent as DoorBell } from '../../../assets/images/doorbell.svg';
import { ReactComponent as Telephone } from '../../../assets/images/telephone.svg';
import { ReactComponent as AlarmIcon } from '../../../assets/images/alarm.svg';
import { ReactComponent as CentralVacuum } from '../../../assets/images/central-vacuum.svg';
import { ReactComponent as HWDispenser } from '../../../assets/images/hw-dispenser.svg';
import { ReactComponent as TrashCompactor } from '../../../assets/images/trash-compactor.svg';
import { ReactComponent as FoodCenter } from '../../../assets/images/food-center.svg';
import { ReactComponent as SepticSystem } from '../../../assets/images/sewer.svg';
import { ReactComponent as RoofIcon } from '../../../assets/images/roof.svg';
import { ReactComponent as ACSystemIcon } from '../../../assets/images/air-conditioner.svg';
import { ReactComponent as KeyEntry } from '../../../assets/images/key-entry.svg';
import { ReactComponent as PestControl } from '../../../assets/images/pest-control.svg';
import { ReactComponent as Laundry } from '../../../assets/images/laundry.svg';
import { ReactComponent as SewagePump } from '../../../assets/images/sewage-pump.svg';
import { ReactComponent as SurgeProtectionIcon } from '../../../assets/images/Vendor/ET/electric-surge.svg';
import { ReactComponent as VehicleChargerIcon } from '../../../assets/images/Vendor/ET/vehicle-charger.svg';
import { ReactComponent as IceMaker } from '../../../assets/images/ice-maker.svg';
import { ReactComponent as PoolIcon } from '../../../assets/images/pool.svg';
import { ReactComponent as StandMixer } from '../../../assets/images/standmixer.svg';
import { ReactComponent as ElectricBike } from '../../../assets/images/electric-bike.svg';
import { ReactComponent as HoverBoard } from '../../../assets/images/hoverboard.svg';
import { ReactComponent as ElectricScooter } from '../../../assets/images/electric-scooter.svg';
import { ReactComponent as GamingConsole } from '../../../assets/images/gaming-console.svg';
import { ReactComponent as GamingAccessory } from '../../../assets/images/gaming-accessory.svg';
import { ReactComponent as GamingController } from '../../../assets/images/gaming-controller.svg';
import { ReactComponent as Tablet } from '../../../assets/images/tablet.svg';
import { ReactComponent as CellPhone } from '../../../assets/images/phone.svg';
import { ReactComponent as Laptop } from '../../../assets/images/laptop.svg';
import { ReactComponent as Desktop } from '../../../assets/images/desktop.svg';
import { ReactComponent as Cooktop } from '../../../assets/images/cooktop.svg';
import { ReactComponent as LaptopPhone } from '../../../assets/images/laptop-phone.svg';
import { ReactComponent as Television } from '../../../assets/images/television.svg';
import { ReactComponent as Oven } from '../../../assets/images/oven.svg';
import { ReactComponent as StackedLaundry } from '../../../assets/images/stacked-laundry.svg';
import { ReactComponent as WarmingDrawer } from '../../../assets/images/warming-drawer.svg';
import { ReactComponent as WineCooler } from '../../../assets/images/wine-cooler.svg';
import { ReactComponent as Printer } from '../../../assets/images/printer.svg';
import { ReactComponent as Camera } from '../../../assets/images/camera.svg';
import { ReactComponent as Projector } from '../../../assets/images/projector.svg';
import { ReactComponent as SecurityCamera } from '../../../assets/images/security-camera.svg';
import { ReactComponent as HomeTheater } from '../../../assets/images/home-theater.svg';
import { ReactComponent as DVDPlayer } from '../../../assets/images/dvd-player.svg';
import { ReactComponent as Speaker } from '../../../assets/images/speaker.svg';
import { ReactComponent as Vaccum } from '../../../assets/images/vacuum.svg';
import { ReactComponent as HomeAudio } from '../../../assets/images/home-audio.svg';
import { ReactComponent as Watch } from '../../../assets/images/watch.svg';
import { ReactComponent as KeyboardMouse } from '../../../assets/images/keyboard-mouse.svg';
import { ReactComponent as WearableTech } from '../../../assets/images/wearable-tech.svg';
import { ReactComponent as Monitor } from '../../../assets/images/monitor.svg';

const AssetIcon = ({ assetName, className }) => {
    if (!assetName) return null;
    return (
        <>
            {assetName.toLowerCase() === 'dishwasher' && <DishwasherIcon className={className} />}
            {assetName.toLowerCase() === 'refrigerator' && <RefrigeratorIcon className={className} />}
            {assetName.toLowerCase() === 'freezer' && <FreezerIcon className={className} />}
            {assetName.replace(/\s/g, '').toLowerCase() === 'externalwaterline' && (
                <ExternalWaterLine className={className} />
            )}
            {assetName.replace(/\s/g, '').toLowerCase() === 'garagedooropener' && (
                <GarageOpener className={className} />
            )}
            {assetName.toLowerCase() === 'ceiling fan' && <CeilingFan className={className} />}
            {assetName.replace(/\s/g, '').toLowerCase() === 'humidifier' && <Humidifier className={className} />}
            {(assetName.replace(/[- )(]/g, '').toLowerCase() === 'microwaveovenbuiltin'
                || assetName.replace(/\s/g, '').toLowerCase() === 'microwave') && (
                <MicrowaveIcon className={className} />
            )}
            {(assetName.replace(/\s/g, '').toLowerCase() === 'kitchenexhaustfan'
                || assetName.replace(/\s/g, '').toLowerCase() === 'exhaustfans') && (
                <ExhaustIcon className={className} />
            )}
            {(assetName.replace(/\s/g, '').toLowerCase() === 'ceiling/exhaustfans'
                || assetName.replace(/\s/g, '').toLowerCase() === 'ceilingfans') && (
                <CeilingFan className={className} />
            )}
            {assetName.replace(/\s/g, '').toLowerCase() === 'waterheater' && <WaterHeater className={className} />}
            {assetName.replace(/\s/g, '').toLowerCase() === 'garbagedisposal' && <DisposalIcon className={className} />}
            {(assetName.replace(/\s/g, '').toLowerCase() === 'centralhomeheatingsyst'
                || assetName.replace(/\s/g, '').toLowerCase() === 'centralheating') && (
                <HeatingSystem className={className} />
            )}
            {assetName.replace(/\s/g, '').toLowerCase() === 'interiorelectricalsyst' && (
                <ElectricalSystem className={className} />
            )}
            {assetName.replace(/[- )(]/g, '').toLowerCase() === 'heatingductwork' && (
                <DuctWorkIcon className={className} />
            )}
            {assetName.replace(/[- )(]/g, '').toLowerCase() === 'plbstoppagesfxtnotinc' && (
                <PlumbingStoppage className={className} />
            )}
            {(assetName.replace(/\s/g, '').toLowerCase() === 'plumbingsystem/stoppages'
                || assetName.replace(/\s/g, '').toLowerCase() === 'plumbing') && (
                <PlumbingStoppage className={className} />
            )}
            {(assetName.replace(/[- )(]/g, '').toLowerCase() === 'plbsysfixturesnotinc'
                || assetName.replace(/\s/g, '')?.toLowerCase() === 'plumbingsystem') && (
                <PlumbingSystem className={className} />
            )}
            {(assetName.replace(/\\|\//g, '').toLowerCase() === 'rangeovenstove'
                || assetName.replace(/\s/g, '').toLowerCase() === 'rangehood') && <RangeIcon className={className} />}
            {assetName.replace(/[- )(]/g, '').toLowerCase() === 'addonspaonly' && <SpaIcon className={className} />}
            {assetName.replace(/[- )(]/g, '').toLowerCase() === 'addonswimmingpoolonly' && (
                <SwimIcon className={className} />
            )}
            {assetName.replace(/[- )(]/g, '').toLowerCase() === 'addonswimmingpool&spa' && (
                <SwimIcon className={className} />
            )}
            {assetName.replace(/\s/g, '').toLowerCase() === 'internalplumbing' && (
                <PlumbingIcon className={className} />
            )}
            {assetName.replace(/\s/g, '').toLowerCase() === 'refrigeratorincicemaker' && (
                <RefrigeratorIcon className={className} />
            )}
            {assetName.replace(/\s/g, '').toLowerCase() === 'wellpump' && <WellPump className={className} />}
            {assetName.toLowerCase() === 'dryer' && <DryerIcon className={className} />}
            {assetName.toLowerCase() === 'washer' && <WasherIcon className={className} />}
            {assetName.toLowerCase() === 'doorbells' && <DoorBell className={className} />}
            {assetName.replace(/\s/g, '').toLowerCase() === 'telephoneline' && <Telephone className={className} />}
            {assetName.replace(/\s/g, '').toLowerCase() === 'burglar/firealarmsystems' && (
                <AlarmIcon className={className} />
            )}
            {assetName.replace(/\s/g, '').toLowerCase() === 'centralvacuumsystem' && (
                <CentralVacuum className={className} />
            )}
            {assetName.replace(/\s/g, '').toLowerCase() === 'hotwaterdispenser' && (
                <HWDispenser className={className} />
            )}
            {(assetName.replace(/[- )(]/g, '').toLowerCase() === 'trashcompactorbuiltin'
                || assetName.replace(/\s/g, '').toLowerCase() === 'trashcompactor') && (
                <TrashCompactor className={className} />
            )}
            {assetName.replace(/[- )(]/g, '').toLowerCase() === 'builtinfoodcenter' && (
                <FoodCenter className={className} />
            )}
            {assetName.replace(/\\|\//g, '').toLowerCase() === 'dexternalwatersewerseptic' && (
                <SepticSystem className={className} />
            )}
            {assetName.replace(/\s/g, '').toLowerCase() === 'roofleakrepair' && <RoofIcon className={className} />}
            {assetName.replace(/\s|\//g, '').toLowerCase() === 'cntrlachpsyselconly' && (
                <ACSystemIcon className={className} />
            )}
            {assetName.replace(/\s/g, '').toLowerCase() === 're-key' && <KeyEntry className={className} />}
            {assetName.replace(/\s/g, '').toLowerCase() === 'pestcontrol' && <PestControl className={className} />}
            {assetName.replace(/\s/g, '').toLowerCase() === 'subterraneantermitetreatment' && (
                <TermiteTreatment className={className} />
            )}
            {assetName.replace(/\s/g, '').toLowerCase() === 'septicsystem' && <SepticSystem className={className} />}
            {assetName.replace(/\s/g, '').toLowerCase() === 'externalsewerline' && (
                <SepticSystem className={className} />
            )}
            {assetName.replace(/\s/g, '').toLowerCase() === 'washeranddryerpair' && <Laundry className={className} />}
            {assetName.replace(/\s/g, '').toLowerCase() === 'sewageejectorpump' && <SewagePump className={className} />}
            {assetName.replace(/\s/g, '').toLowerCase() === 'a/csystem' && <ACSystemIcon className={className} />}
            {assetName.replace(/\s/g, '').toLowerCase() === 'surgeprotection' && (
                <SurgeProtectionIcon className={className} />
            )}
            {assetName.replace(/\s/g, '').toLowerCase() === 'surge' && <SurgeProtectionIcon className={className} />}
            {assetName.replace(/\s/g, '').toLowerCase() === 'electricvehiclecharger' && (
                <VehicleChargerIcon className={className} />
            )}
            {assetName.replace(/\s/g, '').toLowerCase() === 'exteriorelectricline' && (
                <ElectricalSystem className={className} />
            )}
            {assetName.replace(/\s/g, '').toLowerCase() === 'electricalsystems' && (
                <ElectricalSystem className={className} />
            )}
            {assetName?.replace(/\s/g, '')?.toLowerCase() === 'interiorelectricline' && (
                <ElectricalSystem className={className} />
            )}
            {assetName?.replace(/\s/g, '')?.toLowerCase() === 'icemaker' && <IceMaker className={className} />}
            {assetName?.replace(/\s/g, '')?.toLowerCase() === 'spa' && <SpaIcon className={className} />}
            {assetName?.replace(/\s/g, '')?.toLowerCase() === 'swimmingpool' && <SwimIcon className={className} />}
            {assetName?.replace(/\s/g, '')?.toLowerCase() === 'swimmingpoolandspa' && (
                <PoolIcon className={className} />
            )}
            {assetName?.replace(/\s/g, '')?.toLowerCase() === 'countertopkitchenappliances' && (
                <StandMixer className={className} />
            )}
            {assetName?.replace(/\s/g, '')?.toLowerCase() === 'cooktop' && <Cooktop className={className} />}
            {assetName?.replace(/\s/g, '')?.toLowerCase() === 'stackedlaundry' && (
                <StackedLaundry className={className} />
            )}
            {assetName?.replace(/\s/g, '')?.toLowerCase() === 'warmingdrawer' && (
                <WarmingDrawer className={className} />
            )}
            {assetName?.replace(/\s/g, '')?.toLowerCase() === 'winecooler' && <WineCooler className={className} />}
            {assetName?.replace(/\s/g, '')?.toLowerCase() === 'vaccum' && <Vaccum className={className} />}
            {assetName?.replace(/[\s,]/g, '')?.toLowerCase() === 'bicycleelectric' && (
                <ElectricBike className={className} />
            )}
            {assetName?.replace(/[\s,]/g, '')?.toLowerCase() === 'boardelectric' && (
                <HoverBoard className={className} />
            )}
            {assetName?.replace(/[\s,]/g, '')?.toLowerCase() === 'scooterelectric' && (
                <ElectricScooter className={className} />
            )}
            {assetName?.replace(/\s/g, '')?.toLowerCase() === 'gamingconsole' && (
                <GamingConsole className={className} />
            )}
            {assetName?.replace(/\s/g, '')?.toLowerCase() === 'gamingcontroller' && (
                <GamingController className={className} />
            )}
            {assetName?.replace(/\s/g, '')?.toLowerCase() === 'gamingaccessories' && (
                <GamingAccessory className={className} />
            )}
            {assetName?.replace(/\s/g, '')?.toLowerCase() === 'tablet' && <Tablet className={className} />}
            {assetName?.replace(/\s/g, '')?.toLowerCase() === 'cellphone' && <CellPhone className={className} />}
            {assetName?.replace(/\s/g, '')?.toLowerCase() === 'laptop' && <Laptop className={className} />}
            {assetName?.replace(/\s/g, '')?.toLowerCase() === 'desktopcomputer' && <Desktop className={className} />}
            {assetName?.replace(/\s/g, '')?.toLowerCase() === 'consumerelectronics' && (
                <LaptopPhone className={className} />
            )}
            {assetName?.replace(/\s/g, '')?.toLowerCase() === 'television' && <Television className={className} />}
            {assetName?.replace(/\s/g, '')?.toLowerCase() === 'printer' && <Printer className={className} />}
            {assetName?.replace(/\s/g, '')?.toLowerCase() === 'camera' && <Camera className={className} />}
            {assetName?.replace(/\s/g, '')?.toLowerCase() === 'projector' && <Projector className={className} />}
            {assetName?.replace(/\s/g, '')?.toLowerCase() === 'securitycamera' && (
                <SecurityCamera className={className} />
            )}
            {assetName?.replace(/\s/g, '')?.toLowerCase() === 'hometheater' && <HomeTheater className={className} />}
            {assetName?.replace(/[\/\- ]/g, '')?.toLowerCase() === 'dvdblurayplayer' && (
                <DVDPlayer className={className} />
            )}
            {assetName?.replace(/\s/g, '')?.toLowerCase() === 'speaker' && <Speaker className={className} />}
            {assetName?.replace(/\s/g, '')?.toLowerCase() === 'homeaudio' && <HomeAudio className={className} />}
            {assetName?.replace(/\s/g, '')?.toLowerCase() === 'personalelectronics' && <Watch className={className} />}
            {assetName?.replace(/\s/g, '')?.toLowerCase() === 'computeraccessories' && (
                <KeyboardMouse className={className} />
            )}
            {assetName?.replace(/[- )(]/g, '')?.toLowerCase() === 'wearabletechvr' && (
                <WearableTech className={className} />
            )}
            {assetName?.replace(/\s/g, '')?.toLowerCase() === 'oven' && <Oven className={className} />}
            {assetName?.replace(/\s/g, '')?.toLowerCase() === 'homeaudio' && <HomeAudio className={className} />}
            {assetName?.toLowerCase() === 'range' && <RangeIcon className={className} />}
        </>
    );
};

export default AssetIcon;
